module.exports = __webpack_public_path__ + "static/media/support-thumb-4.ab9f45f9.jpg";